import React from "react";
import { formatNumber } from "../../helpers/templateHelpers";
import LoadingSpinner from "../global/LoadingSpinner";

function SingleDataTile(props) {
  let value = props.value;
  let title = props.title;
  let className = props.className;
  let decimalPlaces = props.decimalPlaces;
  let difference = props.difference;
  let prefix = props.prefix;
  let hidePercentage = props.hidePercentage;
  let postfix = props.postfix;
  let isLoading = props.isLoading;

  let differenceClassName =
    difference > 0
      ? "diff positive"
      : difference < 0
      ? "diff negative"
      : "diff zero";

  return (
    <div className="MainTileWrap">
      {isLoading && <div className="adminReportOverlay"><LoadingSpinner className="my-5" /></div>}
      <div className={className}>
        <div className="image">
          <span></span>
        </div>
        <div className="content">
          <p className="value">
            <strong>
              {prefix}
              {value}
              {postfix}
            </strong>
          </p>
          <p className="title">{title}</p>
          {!isNaN(difference) ? (
            <p className={differenceClassName}>
              {difference > 0 && prefix}
              {Number.isInteger(difference) ? difference : formatNumber(difference,1)}
              {!hidePercentage && "%"}
            </p>
          ) : (
            <p className="diff empty"></p>
          )}
        </div>
      </div>
    </div>
  );
}

export default SingleDataTile;
